import React from "react";

function Text({ text }) {
  return <p className="text-[1.5rem] text-[#4E0240]">{text}</p>;
}

export default Text;
